import type { Tag } from "~/models/tag";

  export function tags(tags: Tag[]): string {
    if(tags.length === 0)
        return '';
    
    const rtnTags = tags.slice().sort((a, b) => (a.name > b.name) ? 1 : -1)

    let rtn = '';
    for (let i = 0; i < rtnTags.length; i++) {
        if(i === 0){
            rtn = rtnTags[0].name;
        } else {
            if(rtnTags[i].status === 2)
              rtn = rtn + ' / ' + rtnTags[i].name;
        }
    }

    return rtn;
}